import styled from 'styled-components';
import { up } from '../../styles/media';

// A troca entre os dois menus é feita por CSS (e não por window.matchMedia)
// para não depender de listener de resize nem provocar flash na carga.
export const MobileOnly = styled.div`
  display: block;

  ${up('lg')} {
    display: none;
  }
`;

export const DesktopOnly = styled.div`
  display: none;

  ${up('lg')} {
    display: block;
  }
`;
